export default __webpack_public_path__ + "static/media/mobile_main_top_3x_2.1a55534e.png";